import { render, staticRenderFns } from "./EditArea.vue?vue&type=template&id=28685e13&scoped=true&"
import script from "./EditArea.vue?vue&type=script&lang=js&"
export * from "./EditArea.vue?vue&type=script&lang=js&"
import style0 from "./EditArea.vue?vue&type=style&index=0&id=28685e13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28685e13",
  null
  
)

export default component.exports